import axios from "axios";
import consoleLog from "../utils/consoleLog";

// import { Item } from '../../redux/shop/shop.types';

const API = axios.create({
  baseURL: "https://sandbox.petobe.ca/payment",
});

export const getPublishableKey = async () => {
  return await API.get("/getPublishableKey")
    .then((res) => {
      consoleLog("getPublishableKey success");
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("getPublishableKey failure", err);
      return err;
    });
};

export const createPaymentIntents = async ({
  email,
  currency,
  amount,
  customerId,
  payment_method_id,
}: {
  email: string;
  currency: string;
  amount: number;
  customerId: string;
  payment_method_id?: string;
}) => {
  consoleLog("createPaymentIntents request body", {
    email,
    currency,
    amount,
    customerId,
    payment_method_id,
  });

  return await API.post("/paymentIntents/createPaymentIntents", {
    email,
    currency,
    amount: (amount * 100).toFixed(0),
    customerId,
    payment_method_id,
  })
    .then((res) => {
      consoleLog("createPaymentIntents response", res);
      return res.data;
    })
    .catch((err) => {
      consoleLog("createPaymentIntents error", err);
      return err;
    });
};

export const getPaymentMethods = async ({
  customerId,
}: {
  customerId?: string;
}) => {
  consoleLog("getPaymentMethods request body", {
    customerId,
  });

  return await API.post("/paymentMethod/getPaymentMethods", {
    customerId,
  })
    .then((res) => {
      consoleLog("getPaymentMethods response", res);
      return res.data;
    })
    .catch((err) => {
      consoleLog("getPaymentMethods error", err);
      return err;
    });
};

export const updatePaymentMethod = async ({
  paymentMethodId,
  billingAddress,
  billingEmail,
  billingName,
  billingPhone,
}: {
  paymentMethodId: string;
  billingAddress: {
    city: string;
    country: string;
    line1: string;
    line2?: string;
    postal_code: string;
    state: string;
  };
  billingEmail: string;
  billingName: string;
  billingPhone: string;
}) => {
  consoleLog("updatePaymentMethod request body", {
    paymentMethodId,
    billingAddress,
    billingEmail,
    billingName,
    billingPhone,
  });

  return await API.post("/paymentMethod/updatePaymentMethod", {
    paymentMethodId,
    billingAddress,
    billingEmail,
    billingName,
    billingPhone,
  })
    .then((res) => {
      consoleLog("updatePaymentMethod response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("updatePaymentMethod error", err);
      return err;
    });
};

// export const attachPaymentMethod = async ({
//   paymentMethodId,
//   customerId,
// }: {
//   paymentMethodId: string;
//   customerId: string;
// }) => {
//   consoleLog("attachPaymentMethod request body", {
//     paymentMethodId,
//     customerId,
//   });

//   return await API.post("/paymentMethod/updatePaymentMethod", {
//     paymentMethodId,
//     billingAddress,
//     billingEmail,
//     billingName,
//     billingPhone,
//   })
//     .then((res) => {
//       consoleLog("updatePaymentMethod response", res);
//       return res.data.body;
//     })
//     .catch((err) => {
//       consoleLog("updatePaymentMethod error", err);
//       return err;
//     });
// };

export const createCustomer = async ({
  email,
  name,
  city,
  country,
  line1,
  line2,
  postal_code,
  state,
  username,
}: {
  email: string;
  name: string;
  city: string;
  country: string;
  line1: string;
  line2?: string;
  postal_code: string;
  state: string;
  username: string;
}) => {
  consoleLog("createCustomer request body", {
    email,
    name,
    address: {
      city,
      country,
      line1,
      line2,
      postal_code,
      state,
    },
    metadata: {
      username,
    },
  });

  return await API.post("/customer/createCustomer", {
    email,
    name,
    address: {
      city,
      country,
      line1,
      line2,
      postal_code,
      state,
    },
    metadata: {
      username,
    },
  })
    .then((res) => {
      consoleLog("createCustomer response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("createCustomer error", err);
      return err;
    });
};

export const getCustomer = async ({ customerId }: { customerId: string }) => {
  consoleLog("getCustomer request body", {
    customerId,
  });

  return await API.post("/customer/getCustomer", {
    customerId,
  })
    .then((res) => {
      consoleLog("getCustomer response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("getCustomer error", err);
      return err;
    });
};

export const createShippingAddress = async ({
  customerId,
  shippingAddress,
  shippingName,
  shippingPhone,
}: {
  customerId: string;
  shippingAddress: {
    city: string;
    country: string;
    line1: string;
    line2?: string;
    postal_code: string;
    state: string;
  };
  shippingName: string;
  shippingPhone?: string;
}) => {
  consoleLog("createShippingAddress request body", {
    customerId,
    shippingAddress,
    shippingName,
    shippingPhone,
  });

  return await API.post("/shippingAddress/createShippingAddress ", {
    customerId,
    shippingAddress,
    shippingName,
    shippingPhone,
  })
    .then((res) => {
      consoleLog("createShippingAddress response", res);
      return res.data;
    })
    .catch((err) => {
      consoleLog("createShippingAddress error", err);
      return err;
    });
};
